<template>
  <div class="home">
    <!-- Hero Carousel Section -->
    <HeroCarousel />

    <!-- Enhanced Countdown Section -->
    <section class="section-padding bg-yellow-light" id="countdown-section">
      <div class="container">
        <CountdownTimer />
      </div>
    </section>

    <!-- Enhanced Why Attend Section -->
    <WhyAttendSection />

    <!-- Enhanced Pricing Section -->
    <PricingSection />
  </div>
</template>

<script>
import HeroCarousel from '@/components/HeroCarousel.vue'
import CountdownTimer from '@/components/CountdownTimer.vue'
import WhyAttendSection from '@/components/WhyAttendSection.vue'
import PricingSection from '@/components/PricingSection.vue'

export default {
  name: 'HomeView',
  components: {
    HeroCarousel,
    CountdownTimer,
    WhyAttendSection,
    PricingSection
  }
}
</script>

<style scoped>
/* Simplified styles since most styling is now in components */
.home {
  overflow-x: hidden;
}

/* Smooth scrolling for anchor links */
html {
  scroll-behavior: smooth;
}

/* Section spacing adjustments if needed */
.section-padding {
  padding: var(--spacing-4xl) 0;
}

@media (max-width: 768px) {
  .section-padding {
    padding: var(--spacing-2xl) 0;
  }
}
</style>
